import { Dispatch, FC, SetStateAction, useState } from "react";
import { Dropdown, Menu, Space, Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import {
  DeliveryPoint,
  DeliveryPointData,
  DeliveryPointResponse,
  GetParkingListResponse,
  MasterTransport,
  ParkingListItems,
} from "services/interface";
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { convertTransport } from "utils/convertData";
import { useGetParkingList } from "hooks/useShipping";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
import ModalEditDeliveryPoint from "./ModalEditDeliveryPoint";
interface TableTransportationListProps {
  data: DeliveryPointData[] | undefined;
  onDeleteConfigs: (id: string) => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
  total: string | undefined;
}

const TableDeliveryPoint: FC<TableTransportationListProps> = ({
  data,
  onDeleteConfigs,
  limit,
  offset,
  setLimit,
  setOffset,
  total,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [editData, setEditData] = useState<DeliveryPointData | undefined>();
  const [isMoadlEdit, setIsModalEdit] = useState<boolean>(false);

  const columns: ColumnsType<DeliveryPointData> = [
    {
      title: "ลำดับ",
      dataIndex: "index",
      align: "center",
      key: "index",
      render: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: "ชื่อจุดจอด",
      dataIndex: "delivery_point",
      width: 150,
      render: (_text, record) => {
        return (
          <Typography.Link
            style={{
              cursor: "pointer",
              fontWeight: "400",
              textDecoration: "underline",
            }}
            type="secondary"
            onClick={async () => {
              setEditData(record);
              setIsModalEdit(true);
            }}
          >
            {_text}
          </Typography.Link>
        );
      },
    },
    {
      title: "จังหวัด",
      dataIndex: "province_delivery",
      width: 250,
      render: (_text) => {
        return <Typography.Paragraph>{_text}</Typography.Paragraph>;
      },
    },
    {
      title: "อำเภอ",
      dataIndex: "district_delivery",
      width: 250,
      render: (_text) => {
        return <Typography.Paragraph>{_text}</Typography.Paragraph>;
      },
    },
    {
      title: "Action",
      dataIndex: "transection_code",
      align: "center",
      key: "transection_code",
      fixed: "right",
      width: 100,
      render: (_text, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <Space size="middle">
            <Dropdown
              overlay={
                <Menu>
                  <Menu.Item
                    key="1"
                    onClick={() => {
                      setEditData(record);
                      setIsModalEdit(true);
                    }}
                  >
                    แก้ไข
                  </Menu.Item>
                  <Menu.Item
                    key="2"
                    onClick={() => {
                      onDeleteConfigs(record.id);
                    }}
                  >
                    ลบ
                  </Menu.Item>
                </Menu>
              }
            >
              <div>
                <EllipsisOutlined />
              </div>
            </Dropdown>
          </Space>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
          size="middle"
        scroll={{ x: true }}
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: limit,
          total: parseInt(total || "0"),
          onChange: (page, pageSize) => {
            setLimit(pageSize || 10);
            setOffset((page - 1) * pageSize);
          },
        }}
      />
      <ModalEditDeliveryPoint
        editData={editData}
        showParking={isMoadlEdit}
        onClose={() => {
          setIsModalEdit(false);
        }}
      />
    </div>
  );
};

export default TableDeliveryPoint;
